// build-in library

import { useSelector } from 'react-redux';
// import TotalUnitsInDevelopments from "components/Widgets/TotalUnitsInDevelopmentWidget";
// import TotalForSaleUnitsWidget from "components/Widgets/TotalForSaleUnitsWidget";
// import TotalAffdForSaleUnitsWidget from "components/Widgets/TotalAffdForSaleUnitsWidgets";
// import TotalAffdRentalUnitsWidget from "components/Widgets/TotalAffdRentalUnitsWidget";
// import TotalMarketRentalUnits from "components/Widgets/TotalMarketRentalUnits";
// import AvgSalesPriceAffordableWidget from "components/Widgets/AvgSalesPriceAffordableWidget";
import CityInvestmentWidget from '@/components/Widgets/CityInvestmentWidget';
import DevelopersInvestmentWidget from '@/components/Widgets/DevelopersInvestmentWidget';
import DevelopmentPipelineWidget from '@/components/Widgets/DevelopmentPipelineWidget';
import DistrictImpactWidget from '@/components/Widgets/DistrictImpactWidget';
import NewConstructionSummary from '@/components/Widgets/NewConstructionSummaryWidget';
import ProgrammaticSummary from '@/components/Widgets/ProgrammaticSummaryWidget';
import SourceSpentWidget from '@/components/Widgets/SourceSpentWidget';
import StatusWidget from '@/components/Widgets/StatusWidget';
import TotalProgramsWidget from '@/components/Widgets/TotalProgramsWidget';
import TotalProjectSourcesWidget from '@/components/Widgets/TotalProjectSourcesWidget';
import TotalProjectUsesWidget from '@/components/Widgets/TotalProjectUsesWidget';
import { authSelector } from '@/store';
//Custom Components
import DashboardWidget from '../../../components/DashboardWidget';
import { HasPermission } from '../../../components/Permission/HasPermission';
import ConstructionTypeWidget from '../../../components/Widgets/ConstructionTypeWidget';
import { DashboardName, Widget } from '../../../components/Widgets/constants';
import NeighborhoodImpactWidget from '../../../components/Widgets/NeighborhoodImpactWidget';
import ProgramFinancialWidget from '../../../components/Widgets/ProgramFinancialWidget';
import ProjectBudgetSummaryWidget from '../../../components/Widgets/ProjectBudgetSummaryWidget';
import ProjectLocationWidget from '../../../components/Widgets/ProjectLocationWidget';
import ProjectStatusSummaryWidget from '../../../components/Widgets/ProjectStatusSummaryWidget';
import ProjectTypeWidget from '../../../components/Widgets/ProjectTypeWidget';
import RebuildLoansApprovedWidget from '../../../components/Widgets/RebuildLoansApprovedWidget';
import TotalDevelopersWidget from '../../../components/Widgets/TotalDevelopersWidget';
import TotalProjectsWidget from '../../../components/Widgets/TotalProjectsWidget';
//Services
import { useDashboardWidgetsList } from '../../../hooks/ReactQueryHooks/useDashboardQuery';

import { shouldRenderWidget } from './constants';

function SherpaDashboard({ showButton = true }: { showButton?: boolean }) {
  const { data } = useSelector(authSelector);
  const { isWidgetUsed } = useDashboardWidgetsList({
    dashboard: DashboardName.SHERPA_DASHBOARD,
  });

  return (
    <div className='container mx-auto space-y-4'>
      <div className='-mt-8'>
        <HasPermission of='MANAGE_WIDGETS'>{showButton && <DashboardWidget dashboard={DashboardName.SHERPA_DASHBOARD} />}</HasPermission>
      </div>

      <section className='grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-2'>
        {isWidgetUsed?.[Widget.REBUILD_LOANS_APPROVED] && shouldRenderWidget(Widget.REBUILD_LOANS_APPROVED, data?.account) && (
          <RebuildLoansApprovedWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
        {isWidgetUsed?.[Widget.TOTAL_DEVELOPERS] && shouldRenderWidget(Widget.TOTAL_DEVELOPERS, data?.account) && (
          <TotalDevelopersWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
        {(data?.account === 'birminghamhousing' ||
          (shouldRenderWidget(Widget.TOTAL_PROGRAMS, data?.account) && isWidgetUsed?.[Widget.TOTAL_PROGRAMS])) && (
          <TotalProgramsWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}

        {shouldRenderWidget(Widget.PROJECT_BUDGET_SUMMARY, data?.account) && (
          <DevelopmentPipelineWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
        {shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
          <DevelopersInvestmentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
        {shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
          <CityInvestmentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}

        {isWidgetUsed?.[Widget.TOTAL_PROJECTS] && shouldRenderWidget(Widget.TOTAL_PROJECTS, data?.account) && (
          <TotalProjectsWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
      </section>
      <div className='col-span-1'>
        {shouldRenderWidget(Widget.PROGRAMMATIC_SUMMARY, data?.account) && (
          <ProgrammaticSummary dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
      </div>
      <div className='col-span-1'>
        {shouldRenderWidget(Widget.PROJECTS_SPENDING_SUMMARY_REPORT, data?.account) && (
          <SourceSpentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
      </div>
      <section className='grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4'>
        {shouldRenderWidget(Widget.NEW_CONSTRUCTION_SUMMARY, data?.account) && (
          <div className='col-span-4 2xl:col-span-2'>
            <NewConstructionSummary dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
        {isWidgetUsed?.[Widget.PROJECTS_BY_CONSTRUCTION_TYPE] &&
          shouldRenderWidget(Widget.PROJECTS_BY_CONSTRUCTION_TYPE, data?.account) && (
            <div className='col-span-4 2xl:col-span-2'>
              <ConstructionTypeWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
            </div>
          )}
        {shouldRenderWidget(Widget.PROJECTS_BY_NEIGHBORHOOD_DISTRICT, data?.account) && (
          <div className='col-span-4 2xl:col-span-2'>
            <DistrictImpactWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
        <div className='col-span-4 2xl:col-span-2'>
          {isWidgetUsed?.[Widget.PROJECTS_BY_NEIGHBORHOOD] && shouldRenderWidget(Widget.PROJECTS_BY_NEIGHBORHOOD, data?.account) && (
            <NeighborhoodImpactWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          )}
        </div>
        {isWidgetUsed?.[Widget.PROJECT_LOCATION] && shouldRenderWidget(Widget.PROJECT_LOCATION, data?.account) && (
          <div className='col-span-4'>
            <ProjectLocationWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
        {shouldRenderWidget(Widget.PROJECTS_SUMMARY_REPORT, data?.account) && (
          <div className='col-span-4 2xl:col-span-3'>
            <StatusWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
        {isWidgetUsed?.[Widget.PROJECT_STATUS_SUMMARY] && shouldRenderWidget(Widget.PROJECT_STATUS_SUMMARY, data?.account) && (
          <div className='col-span-4 2xl:col-span-1'>
            <ProjectStatusSummaryWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
      </section>
      <section className='grid xl:grid-cols-2 gap-2'>
        {shouldRenderWidget(Widget.PROJECT_BUDGET_SUMMARY, data?.account) && (
          <div className='col-span-2'>
            {isWidgetUsed?.[Widget.PROJECT_BUDGET_SUMMARY] && <ProjectBudgetSummaryWidget dashboard={DashboardName.SHERPA_DASHBOARD} />}
          </div>
        )}
        {isWidgetUsed?.[Widget.PROJECT_FINANCIAL] && shouldRenderWidget(Widget.PROJECT_FINANCIAL, data?.account) && (
          <ProgramFinancialWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
        {isWidgetUsed?.[Widget.PROJECTS_BY_PROJECT_TYPE] && shouldRenderWidget(Widget.PROJECTS_BY_PROJECT_TYPE, data?.account) && (
          <ProjectTypeWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}

        {shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
          <div className='col-span-2'>
            <TotalProjectSourcesWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
        {shouldRenderWidget(Widget.PROJECTS_BY_USES, data?.account) && (
          <div className='col-span-2 '>
            <TotalProjectUsesWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
      </section>
    </div>
  );
}

export default SherpaDashboard;
